export const DELETE_TUNNEL_ACTION_AUTH = 'delete_tunnel_action';
export const EDIT_TUNNEL_ACTION_AUTH = 'edit_tunnel_action';
export const ADD_TUNNEL_ACTION_AUTH = 'add_tunnel_action';
export const ROUTES_DEVICES_AUTH = 'routes_devices';
export const ROUTES_TUNNELS_AUTH = 'routes_tunnels';
export const ROUTES_CHANGEDEVICEOWNER_AUTH = 'routes_changedeviceowner';
export const ROUTES_USERS_AUTH = 'routes_users';
export const ROUTES_USAGE_AUTH = 'routes_usage';
